import { Components, Theme } from '@mui/material/styles';

import { NonHoverBorder } from 'src/theme/colors';

const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    colorPrimary: ({ theme }) => ({
      '&.Mui-checked': {
        '&:hover': {
          backgroundColor: 'transparent',
        },
      },
      color: NonHoverBorder,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.primary.main,
      },
    }),
  },
};

export default MuiRadio;
